import React, { useContext, useEffect, } from "react";
import { CenterComponent } from "./components/common/CenterComponent";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { useNavigate } from "react-router-dom";
import { TenantContext, UserContext } from "./contexts/ContextWrapper";
import { getNavigationAddress } from "./helpers/NavigationHelper";
import { AuthContext } from "./contexts/AuthContext";
import { IsVerbose } from "./helpers/Console";

const Home: React.FC = () => {
    const { tenantContext } = useContext(TenantContext);
    const { userContext } = useContext(UserContext);
    const { isInitializing } = useContext(AuthContext);
    // const {setMessageContext}=useContext(MessageContext);
    const navigate = useNavigate();

    useEffect(() => {
        // Don't do anything while initializing
        if (isInitializing) {
            IsVerbose() && console.log('Home.tsx: Waiting for auth initialization...');
            return;
        }

        let timeoutId: NodeJS.Timeout;

        IsVerbose() && console.log('Home.tsx: tenantContext.api:', tenantContext.api, 'tenantContext.tenantName:', tenantContext.tenantName)

        if (!tenantContext.api || !tenantContext.tenantName) {
            timeoutId = setTimeout(() => {
                // Only redirect if still not loaded after delay
                if (!tenantContext.api || !tenantContext.tenantName) {
                    IsVerbose() && console.log('Home.tsx: useEffect: navigate to /login - tenant context not available after timeout')
                    navigate('/login');
                }
            }, 3000); // Increased to 3 seconds to give more time
        } else {
            const page: string = localStorage.getItem('selectedPage') || 'home';
            IsVerbose() && console.log('Home.tsx: useEffect: navigate to', getNavigationAddress(tenantContext.tenantName, tenantContext.api, userContext.userData.Domains, page))
            navigate(getNavigationAddress(tenantContext.tenantName, tenantContext.api, userContext.userData.Domains, page));
        }

        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [tenantContext.api, tenantContext.tenantName, isInitializing, navigate, userContext.userData.Domains]);

    return (
        <CenterComponent>
            <Spinner className='spinner' size={SpinnerSize.large} label='Redirecting...' />
        </CenterComponent>
    );
}

export default Home;
